define('root/Assets/Templates/Content/Slider/Js/Slider',[
	'jquery',
	'root/Assets/Templates/Content/Slider/Js/Modules/MbiSwiper',
	'base/MbiMediaQuery',
	'base/MbiHelper'
	
	
], function(
	$,
	mbiSwiper,
	mbiMq,
	_
)
{
	'use strict';
	// ----------------------------------------------------------------
	// SWIPER 2 SETUP
	// ----------------------------------------------------------------

	$('.js_swiper').each(function() {
		

		var id = $(this).attr('id'), // create swiper with id assigned to container
			data = $('#'+id).data(),

			args = {

				roundLengths: 		true,
				resizeFix: 			true,
				grabCursor: 		true,

				wrapperClass: 		'js_swiper__wrapper',
				slideClass: 		'js_swiper__slide',
				slideActiveClass: 	'swiper__slide--active',
				slideVisibleClass: 	'swiper__slide--visible',
				noSwipingClass: 	'swiper--no-swiping',
				speed:  			600,
				lazyLoading: 		true 

			};

		if('swiperLoop' in data) {
			if(data.swiperLoop === true) {
				args.loop = true;
			}
		}

		if('swiperAutoplay' in data) {
			if(data.swiperAutoplay === true) {
				args.autoplay = 5000;
			} else if(data.swiperAutoplay === parseInt(data.swiperAutoplay, 10)) { // if is integer
				args.autoplay = data.swiperAutoplay;
			}
		}

		if('swiperInitPrev' in data) {
			args.prevButton = data.swiperInitPrev;
		}
		if('swiperInitNext' in data) {
			args.nextButton = data.swiperInitNext;
		}

		if('swiperInitPagination' in data) {
			args.initPagination = data.swiperInitPagination;
		}
		if('swiperPaginationType' in data) {
			args.paginationType = data.swiperPaginationType;
		}
		if('swiperEffect' in data) {
			args.effect = data.swiperEffect;
		}

		// ----------------------------------------------------------------

		args.watchActiveIndex = true;
		args.keyboardControl = true;
	

		// ----------------------------------------------------------------

		if(id == 'swiper_start') {
			
			var changeHandler = function(swiper) {
				//var index = $(swiper.activeSlide()).attr('data-index');
				var index = $(swiper.slides[swiper.activeIndex]).attr('data-index');
				

				// ----------------------------------------------------------------

				var $slidesContainer = $('.js_startslider'),
					$slides = $slidesContainer.find('.js_slide'),
					
					$activeSlide = $slidesContainer.find('.js_slide[data-index="'+index+'"]'),
					slides = swiper.slides.length;

				$slides.removeClass('is_active');
				$activeSlide.addClass('is_active');
				
				
			}
			var createdHandler = function(swiper) {
				
				changeHandler(swiper);				

					

			}
			args.onInit =		createdHandler;
			args.onSlideChangeStart =	changeHandler;
			args.onSlideChangeEnd =		changeHandler;
			// args.autoplay = 4000;
			// args.autoplay = false;

			

			$(window).on('resize', function() {			
				//mbiSwiper.swiperResize();
				// var swiper = mbiSwiper.swiperObjects['swiper_start'].swiper;

				// if('pad+' in mbiMq.mqArea) {
				// 	swiper.params.noSwiping = true;
				// 	swiper.reInit();
				// 	//if (swiper.params.autoplay == 8000) {
				// 		swiper.startAutoplay();
				// 	//}

				// } else {
				// 	swiper.params.noSwiping = true;
				// var swiper = mbiSwiper.swiperObjects['swiper_start'].swiper;
				// swiper.reInit();
					
					
				// }

			});
			

			// @todo: consider moving this
			$.fn.delayedAction = function(options) {

				var settings = $.extend({}, {
					delayedAction : function() {},
					cancelledAction: function() {},
					hoverTime: 1000
				}, options);

				return this.each(function(){
					var $this = $(this);
					$this.hover(function(){
						$this.data('timerId',
							setTimeout(function(){
								$this.data('hover',false);
								settings.delayedAction($this);
							},settings.hoverTime));
						$this.data('hover',true);
					},
					function(){
						if($this.data('hover')){
							clearTimeout($this.data('timerId'));
							settings.cancelledAction($this);
						}
						$this.data('hover',false);
					} );
				});

			};

		}

		// ----------------------------------------------------------------

		var options = { base: args };
	
		mbiSwiper.createSwiper(id, options);
		
	});

	
	

});
